import cx from 'classnames';
import {getVendorNameFromRegistry} from '~/ViewInvitation/utils/registry';
import {ClickOutLineIcon} from '~library/svg/ClickOutLineIcon';

export const VendorRect = ({
  reversed,
  registry,
  displayText,
  className,
  dataQaId = 'vendor-disc__gifting_link',
}) => {
  const iconUrl = registry.iconUrl || registry.icon_url;
  const vendorName = getVendorNameFromRegistry(registry);
  const reversedClassName = reversed ? '--reversed' : '';

  return (
    <a
      href={registry?.url || ''}
      className={cx('vendor-rect__link', `gift-option__${vendorName.toLowerCase()}`, className)}
      target="_blank"
      data-qa-id={dataQaId}
      data-impression-tracking="true"
      data-qa-locator="vendor-disc" // so that the discs have locators without editing data-qa-id
      data-qa-value={vendorName}
      rel="noreferrer"
    >
      <div className={`gift-option__left${reversedClassName} font_20`}>
        {displayText}
        <img src={iconUrl} alt={vendorName} />
      </div>
      <ClickOutLineIcon ratio={0.5} />
    </a>
  );
};
